import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { HelperFunctions, User } from '@curbnturf/entities';

@Component({
  standalone: true,
  selector: 'curbnturf-user-image',
  templateUrl: './user-image.component.html',
  styleUrls: ['./user-image.component.scss'],
  imports: [NgIf],
})
export class UserImageComponent {
  @Input() user: User;
  @Input() showName = true;

  getPhotoUrl = HelperFunctions.getPhotoUrlSquareThumbnail;
}
